import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import { queryListStyles } from '../../Styles/queryStyles';
import { inject, observer } from 'mobx-react';
import CircularProgress from '@material-ui/core/CircularProgress';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import Images from '../../Theme/Images';
import { ReactSVG } from 'react-svg';
import { ExpansionPanelActions } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Moment from 'moment';
@inject('queryStore', 'commonStore')
@observer
class LatestTicket extends Component {
    state = {
        showAlternateQueries: false
    }

    componentDidMount() {
        this.props.queryStore.reupload()
    }

    onClickDownload = () => {
        const { item } = this.props;
        //const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = item.allStepsData.step_2.apiURL;
        document.body.appendChild(link);
        link.click();

    }

    renderQueryStatus = (type, tempId, currentQuery) => {
        const { classes, item } = this.props;
        if (type === 'download')
            return (
                <ReactSVG
                    beforeInjection={svg => {
                        svg.classList.add(classes.icons)
                    }}
                    src={Images[`${type}`]} onClick={(event) => this.onClickDownload()} />
            )
        return (
            <ReactSVG
                beforeInjection={svg => {
                    svg.classList.add(classes.icons)
                }}
                src={Images[`${type}`]} />
        )
    }

    renderQuerySummary = () => {
        const { classes, item } = this.props
        return (
            <div>
                <div className={classes.intentHeading}>{item.allStepsData.textToShow}</div>
                <div className={classes.policyNoText}>Policy Number: {item.stepsData.step_1.stepData_policyId}</div>
                <div className={classes.dateContainer}>
                    <span className={classes.detail}><ReactSVG className={classes.detailIcon} src={Images.ticket} />&nbsp;{ item.tempId}</span>
                    <span className={classes.time}><ReactSVG className={classes.detailIcon} src={Images.time} />&nbsp;{Moment(item.createdAt).format('DD/MM/YYYY, h:mm a')}</span>
                </div>
            </div>
        )
    }




    onClickSatisfactionButton = (type) => {
        this.props.queryStore.setShowFeedback(true);
        this.props.commonStore.setGoBackTo('pendingQueries')
        this.props.history.push({
            pathname: '/feedback',
            appState: { item: this.props.item, type: type }
        })
    }

    renderSatisfactionButtons = () => {
        const { classes } = this.props;
        return (
            <div className={classes.footerContainer}>
                <Button className={classes.footerButton} type="submit" onClick={(event) => this.onClickSatisfactionButton('satisfied')}>
                    Satisfied
                </Button>
                <Button className={classes.footerButton} type="submit" onClick={(event) => this.onClickSatisfactionButton('dissatisfied')}>
                    Dissatisfied
                </Button>
            </div>
        )
    }

    renderFooter = () => {
        const { item } = this.props;
        if (!item.permanentId) {
            return (
                <div style={{ width: '100%' }}>
                    {
                        (!item.allStepsData.noInputStep ?
                            (item.allStepsData.step_2 && item.allStepsData.step_2.inputType == 'DISPLAY_DOWNLOAD_BUTTON' || item.allStepsData.step_2.inputType == 'DISPLAY_TEXT' ?
                                this.renderSatisfactionButtons() :
                                null) :
                            (item.allStepsData.step_2 && item.allStepsData.noInputStep && item.allStepsData.step_2.inputType != 'FORM' ?
                                this.renderSatisfactionButtons() :
                                (
                                    (this.props.intent != 'completed' ?
                                        <div>Open claim registration form</div> : null
                                    )
                                )
                            )
                        )
                    }
                </div>
            )
        }
    }

    notYourQuery = (item) => {
        this.props.history.push(`/queries/pending/${item.tempId}`)
    }

    expandQuery = (index, value) => {
        this.props.queryStore.expandQuery(index, value)
    }

    getQueryDetails = () => {
        this.props.history.push({
            pathname: '/queries/pending',
            state: { type: "pending" }
        })
    }

    render() {
        const { classes, item, index } = this.props;
        const { inProgress } = this.props.queryStore;
        const { showAlternateQueries } = this.state;
        return (
            <div className={classes.latestQueryCard}>
                <Card className={classes.latestTicket} onClick={(e) => this.getQueryDetails()} >
                    <CardContent
                        className={classes.expansionPanel}
                    >
                        {this.renderQuerySummary()}

                    </CardContent>
                </Card></div>
        )
    }
}
LatestTicket.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter((withStyles(queryListStyles)(LatestTicket)));
